import { render, staticRenderFns } from "./my_transaction_info.vue?vue&type=template&id=5ae678fe&scoped=true"
import script from "./my_transaction_info.vue?vue&type=script&lang=js"
export * from "./my_transaction_info.vue?vue&type=script&lang=js"
import style0 from "./my_transaction_info.vue?vue&type=style&index=0&id=5ae678fe&prod&scoped=true&lang=css"
import style1 from "./my_transaction_info.vue?vue&type=style&index=1&id=5ae678fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae678fe",
  null
  
)

export default component.exports